import { Chip } from '@/shared/ui/chip'
import { Icon } from '@/shared/ui/icon'

// Метка «доска открыта заказчику» — в списке досок проекта: открытость наружу
// компании обязана читаться без захода на доску, она дороже её прочих атрибутов.
export function BoardCustomerVisibleBadge({ className }: { className?: string }) {
  return (
    <Chip
      tone="info"
      title="Заказчик компании видит эту доску — и на ней задачи, помеченные ему"
      {...(className ? { className } : {})}
    >
      <Icon name="eye" size={12} />
      Видна клиенту
    </Chip>
  )
}
